import {
  useSearchParams,
  useNavigate,
  useLocation,
  createSearchParams,
} from 'react-router';

export class QueryStringNames {
  // public static readonly MultiSelect = 'multiSelect';

  static MultiSelect = {
    Postions: 'positions',
    PartTypes: 'partTypes',
  };
}

const useQueryStringParameters = () => {
  // Get and set search parameters
  const [searchParams, setSearchParams] = useSearchParams();
  const navigate = useNavigate();
  const location = useLocation();

  const getQueryParam = ({ param }: { param: string }): string | null => {
    return searchParams.get(param);
  };

  const updateQueryParam = ({
    param,
    value,
  }: {
    param: string;
    value: string;
  }) => {
    // Create new URLSearchParams object based on current params
    const newSearchParams = new URLSearchParams(searchParams.toString());
    // Set the new value
    newSearchParams.set(param, value);
    // Update the URL without reloading
    setSearchParams(newSearchParams);
  };

  const navigateWithParams = (
    path: string,
    paramsObject: Record<string, string>,
  ) => {
    navigate({
      pathname: path,
      search: createSearchParams(paramsObject).toString(),
    });
  };

  return { getQueryParam, updateQueryParam, navigateWithParams };
};

export default useQueryStringParameters;
